'use strict';

angular.module('licensure.services')
    .factory('TriggerConfigurationTriggers', ['$http', '$q', function ($http, $q) {
        var get = function (trigger_configuration_id, noCategory) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/triggerconfigurationtriggers', {
                    params: {
                        trigger_configuration_id: trigger_configuration_id,
                        noCategory: noCategory
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getByID = function (id, license_id) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/triggerconfigurationtriggers/' + id, {
                    params: {
                        license_id: license_id
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getByTriggerID = function (id, license_id) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/triggerconfigurationtriggers/getbytriggerid', {
                    params: {
                        trigger_id: id,
                        license_id: license_id
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getLogs = function (triggerArray) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/triggerconfigurationtriggers/getlogs', {
                    params: {
                        lookup: JSON.stringify(triggerArray)
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var getActions = function (tct, infiniteCheck, license_id) {
            var d = $q.defer();
            var promises = [];
            tct.infiniteFound = false;
            tct.actions = [];

            if (tct.user_status_id != null) {
                var action = {};
                action.name = 'User Status';
                action.value = tct.user_status_name;
                action.next_trigger = null;
                action.sort_order = 1;
                tct.actions.push(action);
            }
            if (tct.attendee_status_id != null) {
                var action = {};
                action.name = 'Course Attendee Status';
                action.value = tct.attendee_status_name;
                action.next_trigger = null;
                action.sort_order = 2;
                tct.actions.push(action);
            }
            if (typeof tct.certification_statuses !== 'undefined') {
                tct.certification_statuses.forEach(function (status) {
                    var action = {};
                    action.name = status.category_name;
                    action.value = status.name;
                    action.next_trigger = null;
                    action.sort_order = 3;
                    tct.actions.push(action);
                })
            }
            if (typeof tct.createalerts !== 'undefined') {
                tct.createalerts.forEach(function (alert) {
                    promises.push(getNextTrigger(alert.id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                        if (nextTrigger != null) {
                            if (nextTrigger.infiniteFound) {
                                tct.infiniteFound = true;
                            }
                        }

                        var action = {};
                        action.name = 'Create Alert';
                        action.value = alert.name;
                        action.next_trigger = nextTrigger;
                        action.sort_order = 4;
                        tct.actions.push(action);
                    }));
                })
            }
            if (typeof tct.retirealerts !== 'undefined') {
                tct.retirealerts.forEach(function (alert) {
                    var action = {};
                    action.name = 'Retire Alert';
                    action.value = alert.name;
                    action.next_trigger = null;
                    action.sort_order = 5;
                    tct.actions.push(action);
                })
            }
            if (tct.policy_status_id != null) {
                var action = {};
                action.name = 'Policy Status';
                action.value = tct.policy_status_name;
                action.next_trigger = null;
                action.sort_order = 6;
                tct.actions.push(action);
            }
            if (tct.license_request_status_id != null) {
                promises.push(getNextTrigger(tct.license_request_status_id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                    if (nextTrigger != null) {
                        if (nextTrigger.infiniteFound) {
                            tct.infiniteFound = true;
                        }
                    }

                    var action = {};
                    action.name = 'Application Status';
                    action.value = tct.license_request_status_name;
                    action.next_trigger = nextTrigger;
                    action.sort_order = 7;
                    tct.actions.push(action);
                }));
            }
            if (typeof tct.process_statuses !== 'undefined') {
                tct.process_statuses.forEach(function (processStatus) {
                    if (processStatus.id != null && processStatus.status_id != null) {
                        promises.push(getNextTrigger(processStatus.id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                            if (nextTrigger != null) {
                                if (nextTrigger.infiniteFound) {
                                    tct.infiniteFound = true;
                                }
                            }

                            var action = {};
                            action.name = 'Process';
                            action.value = processStatus.process_name + '-' + processStatus.status_name;
                            action.next_trigger = nextTrigger;
                            action.sort_order = 8;
                            tct.actions.push(action);
                        }));
                    }
                })
            }
            if (typeof tct.form_packages !== 'undefined') {
                tct.form_packages.forEach(function (formPackage) {
                    promises.push(getNextTrigger(formPackage.id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                        if (nextTrigger != null) {
                            if (nextTrigger.infiniteFound) {
                                tct.infiniteFound = true;
                            }
                        }

                        var action = {};
                        action.name = 'Form Package';
                        action.value = formPackage.name + ' (Forms: ';
                        formPackage.forms.forEach(function (form, index) {
                            if (index > 0) {
                                action.value += ', ';
                            }
                            action.value += form.name;
                        })
                        action.value += ')';
                        action.next_trigger = nextTrigger;
                        action.sort_order = 9;
                        tct.actions.push(action);
                    }));
                })
            }
            if (typeof tct.forms !== 'undefined') {
                tct.forms.forEach(function (form) {
                    var action = {};
                    action.name = 'Form';
                    action.value = form.name;
                    action.next_trigger = null;
                    action.sort_order = 10;
                    tct.actions.push(action);
                })
            }
            if (typeof tct.merge_templates !== 'undefined') {
                tct.merge_templates.forEach(function (mergeTemplate) {
                    promises.push(getNextTrigger(mergeTemplate.id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                        if (nextTrigger != null) {
                            if (nextTrigger.infiniteFound) {
                                tct.infiniteFound = true;
                            }
                        }

                        var action = {};
                        action.name = 'Merge Template';
                        action.value = mergeTemplate.name;
                        action.next_trigger = nextTrigger;
                        action.sort_order = 11;
                        tct.actions.push(action);
                    }));
                })
            }
            if (typeof tct.trigger_functions !== 'undefined') {
                tct.trigger_functions.forEach(function (triggerFunction, index) {
                    promises.push(getNextTrigger(triggerFunction.id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTriggers) {
                        var action = {};

                        if (nextTriggers != null) {
                            //if 'nextTriggers' is an array, then it contains more than one new triggers (Case in a configuration, there exists multiple triggers that is initiated by a trigger function).
                            if (Array.isArray(nextTriggers)) {
                                nextTriggers.forEach(function (trigger) {
                                    if (trigger.infiniteFound) {
                                        tct.infiniteFound = true;
                                    }
                                });
                                // At the moment, 'action.next_trigger' can hold only one next trigger, not multiple next triggers; hence, let set it to 'null' in this case. 
                                action.next_trigger = null;
                            }
                            else {
                                if (nextTriggers != null) {
                                    if (nextTriggers.infiniteFound) {
                                        tct.infiniteFound = true;
                                    }
                                }

                                action.next_trigger = nextTriggers;
                            }
                        }
                        else // case when nextTriggers == null:
                        {
                            action.next_trigger = null;
                        }

                        action.name = 'Trigger Function';
                        action.value = triggerFunction.name;
                        action.sort_order = 12 + index;
                        tct.actions.push(action);
                    }));
                })
            }
            if (tct.license_status_id != null) {
                promises.push(getNextTrigger(tct.license_status_id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                    if (nextTrigger != null) {
                        if (nextTrigger.infiniteFound) {
                            tct.infiniteFound = true;
                        }
                    }

                    var action = {};
                    action.name = 'License Status';
                    action.value = tct.license_status_name;
                    action.next_trigger = nextTrigger;
                    action.sort_order = 13;
                    tct.actions.push(action);
                }));
            }
            if (tct.transaction_status_id != null) {
                promises.push(getNextTrigger(tct.transaction_status_id, tct.trigger_configuration_id, infiniteCheck, license_id).then(function (nextTrigger) {
                    if (nextTrigger != null) {
                        if (nextTrigger.infiniteFound) {
                            tct.infiniteFound = true;
                        }
                    }

                    var action = {};
                    action.name = 'Transaction Status';
                    action.value = tct.transaction_status_name;
                    action.next_trigger = nextTrigger;
                    action.sort_order = 14;
                    tct.actions.push(action);
                }));
            }

            $q.all(promises).then(function () {
                d.resolve(tct);
            }).catch(function (response) {
                // handle error
            });

            return d.promise;
        }

        /**
         * The method returns 'trigger_configuration_triggers' object by id and license id and set 'foundInfinite' to true if id matches with an element in 'infiniteCheck' array.
         * @param id - Trigger configuration trigger's id.
         * @param infiniteCheck - An array consists of trigger_configuration_triggers ids used to detect infinite loop.
         * @param license_id - Licence id.
         * @returns An object of trigger_configuration_triggers for specific id and license id.
         */
        var getByIDWithActions = function (id, infiniteCheck, license_id) {
            var d = $q.defer();

            if (infiniteCheck == null) {
                infiniteCheck = [];
            }

            var foundInfinite = false;
            infiniteCheck.forEach(function (check) {
                if (check == id) {
                    foundInfinite = true;
                }
            });

            if (!foundInfinite) {
                infiniteCheck.push(id);

                getByID(id, license_id).then(function (tct) {
                    getActions(tct, infiniteCheck, license_id).then(function (tctActions) {
                        d.resolve(tctActions);
                    });
                });
            }
            else {
                getByID(id, license_id).then(function (tct) {
                    tct.actions = [];
                    
                    tct.infiniteFound = true;
                    d.resolve(tct);
                });
            }

            return d.promise;
        }

        var getByObjectWithActions = function (tct, infiniteCheck, license_id) {
            var d = $q.defer();

            if (infiniteCheck == null) {
                infiniteCheck = [];
            }

            var foundInfinite = false;
            infiniteCheck.forEach(function (check) {
                if (check == tct.id) {
                    foundInfinite = true;
                }
            });

            if (!foundInfinite) {
                infiniteCheck.push(tct.id);
                getActions(tct, infiniteCheck, license_id).then(function (tctActions) {
                    d.resolve(tctActions);
                });
            }
            else {
                tct.actions = [];
                tct.infiniteFound = true;
                d.resolve(tct);
            }

            return d.promise;
        }

        /**
         * The method returns 'trigger_configuration_triggers' object by object id and trigger configuration id.
         * @param object_id - An object id (typically, it is the id associated with a trigger action).
         * @param trigger_configuration_id - A trigger configuration id.
         * @returns An object of trigger_configuration_triggers for specific object id and trigger configuration id.
         */
        var getByObject = function (object_id, trigger_configuration_id) {
            var d = $q.defer();
            $http
                .get(apiLocation + '/api/triggerconfigurationtriggers/getbyobject', {
                    params: {
                        object_id: object_id,
                        trigger_configuration_id: trigger_configuration_id
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        /**
         * The method returns next trigger configuration triggers associated with the trigger action in the current trigger configuration trigger.
         * @param object_id - An object id (typically, it is the id associated with a trigger action).
         * @param trigger_configuration_id - A trigger configuration id.
         * @param infiniteCheck - An array consists of trigger_configuration_triggers ids used to detect infinite loop.
         * @param license_id - A license id.
         * @returns An object of trigger_configuration_triggers for specific object id and trigger configuration id.
         */
        var getNextTrigger = function (object_id, trigger_configuration_id, infiniteCheck, license_id) {
            var d = $q.defer();

            getByObject(object_id, trigger_configuration_id).then(function (new_tcts) {
                if (new_tcts != null && new_tcts.length === 1) {
                    var singleTct = new_tcts[0];
                    if (singleTct != null && singleTct.id != null) {
                        getByIDWithActions(singleTct.id, infiniteCheck, license_id).then(function (trigger) {
                            d.resolve(trigger);
                        });
                    } else {
                        d.resolve(null);
                    }
                }
                //Verification trigger can initiates multiple triggers; therefore, new_tcts could contains 2 ids.
                else if (new_tcts != null && new_tcts.length > 1) {
                    // FIX: Clone infiniteCheck for each branch independently to prevent
                    // false positive loop detection when multiple branches converge
                    // to the same downstream trigger (e.g., multiple NREMT results
                    // all setting the same application status).
                    var promises = new_tcts.map(function (tct) {
                        if (tct != null && tct.id != null) {
                            var branchInfiniteCheck = infiniteCheck.slice();
                            return getByIDWithActions(tct.id, branchInfiniteCheck, license_id);
                        } else {
                            return $q.resolve(null);
                        }
                    });

                    // Wait for all promises to resolve
                    $q.all(promises).then(function (triggers) {
                        d.resolve(triggers);
                    }).catch(function (response) {
                        // handle error
                    });
                } else {
                    d.resolve(null);
                }
            });

            return d.promise;
        }

        var save = function (tct, license_id) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/triggerconfigurationtriggers/';
            if (!isUndefined(tct.id)) {
                method = 'PUT';
                url += tct.id;
            }

            $http({
                method: method,
                url: url,
                data: {
                    trigger_configuration_trigger: tct,
                    merge_templates: tct.merge_templates,
                    form_packages: tct.form_packages,
                    forms: tct.forms,
                    license_category_certification_statues: tct.certification_statuses,
                    process_statuses: tct.process_statuses,
                    createalerts: tct.createalerts,
                    retirealerts: tct.retirealerts,
                    trigger_functions: tct.trigger_functions,
                    license_id: license_id,
                    removed: false
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var remove = function (tct) {
            var d = $q.defer();

            var method = 'PUT';
            var url = apiLocation + '/api/triggerconfigurationtriggers/' + tct.id;

            tct.license_status = null;
            tct.license_status_id = null;
            tct.license_request_status = null;
            tct.license_request_status_id = null;
            tct.user_status_id = null;
            tct.policy_status_id = null;
            tct.transaction_status_id = null;

            $http({
                method: method,
                url: url,
                data: {
                    trigger_configuration_trigger: tct,
                    merge_templates: [],
                    form_packages: [],
                    forms: [],
                    license_category_certification_statues: [],
                    process_statuses: [],
                    createalerts: [],
                    retirealerts: [],
                    trigger_functions: [],
                    removed: true
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            getByObjectWithActions: getByObjectWithActions,

            get: get,

            getByID: getByID,

            getActions: getActions,

            getByTriggerID: getByTriggerID,

            getByIDWithActions: getByIDWithActions,

            getLogs: getLogs,

            save: save,

            remove: remove
        }
    }])
    ;